import { FormTemplate } from '@src/core';

const Collect1Form: FormTemplate = {
  title: 'Questionário Puérpera',
  subtitle: 'Questionário 1: alta hospitalar (1° ao 3° dia pós-parto)',
  steps: [
    {
      title: 'Dados do Prontuário',
      questions: {
        hospitalRegister: {
          sequence: 3,
          type: 'text',
          fieldType: 'number',
          label: 'Registro Hospitalar',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
        hospitalBed: {
          sequence: 4,
          type: 'text',
          fieldType: 'number',
          label: 'Número do Leito',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
      },
    },
    {
      title: 'Dados de Caracterização da Mulher',
      questions: {
        age: {
          sequence: 8,
          type: 'text',
          label: 'Idade',
          fieldType: 'number',
          validator: {
            dataType: 'number',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
        education: {
          sequence: 9,
          layout: '1-column',
          type: 'radio',
          label: 'ESCOLARIDADE: Até que ano você estudou?',
          options: [
            'Não alfabetizada',
            'Fundamental I (1ª a 5ª série)',
            'Fundamental II (6ª a 9ª série)',
            'Médio (antigo 2ª grau)',
            'Superior',
          ],
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          requestDetail: {
            required: true,
            label: 'Detalhe, concluído até:',
            options: [
              'Não informado',
              {
                groupName: 'Fundamental I (1ª a 5ª série)',
                options: ['1ª série', '2ª série', '3ª série', '4ª série', '5ª série'],
              },
              {
                groupName: 'Fundamental II (6ª a 9ª série)',
                options: ['6ª série', '7ª série', '8ª série', '9ª série'],
              },
              { groupName: 'Médio (antigo 2ª grau)', options: ['1º ano', '2º ano', '3º ano'] },
              { groupName: 'Superior', options: ['Completo', 'Incompleto'] },
            ],
          },
        },
        maritalSituation: {
          sequence: 10,
          layout: '1-column',
          type: 'radio',
          label: 'SITUAÇÃO CONJUGAL?',
          options: ['Com companheiro', 'Sem companheiro'],
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
        },
      },
    },
    {
      title: 'Dados Obstétricos',
      questions: {
        'question01': {
          sequence: 11,
          type: 'imc',
          label: '1. Índice de Massa Corporal pré-gestacional?',
          validator: {
            dataType: 'object',
            required: true,
          },
          fullWidth: true,
        },
        'question02': {
          sequence: 12,
          type: 'imc',
          label: '2. Índice de Massa Corporal atual?',
          validator: {
            dataType: 'object',
            required: true,
          },
          fullWidth: true,
        },
        'question03': {
          sequence: 13,
          type: 'text',
          fieldType: 'number',
          label: '3. Idade gestacional completa?',
          placeholder: 'em semanas',
          validator: {
            dataType: 'number',
            required: true,
          },
          fullWidth: true,
          decoration: true,
        },
        'question04': {
          sequence: 14,
          type: 'text',
          fieldType: 'number',
          label: '4. Número de gestações?',
          placeholder: 'quantidade',
          validator: {
            dataType: 'number',
            required: true,
          },
          fullWidth: true,
          decoration: true,
        },
        'question05': {
          sequence: 15,
          type: 'radio',
          label: '5. Paridade?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Nulípara', 'Primípara', 'Multípara - partos anteriores'],
          requestDetails: [
            {
              id: 'VaginalBirth',
              label: 'Parto vaginal:',
              conditions: [{ condition: 'Multípara - partos anteriores' }],
              placeholder: 'quantidade',
              fieldType: 'number',
            },
            {
              id: 'AssistedVaginalBirth',
              label: 'Parto vaginal assistido:',
              conditions: [{ condition: 'Multípara - partos anteriores' }],
              placeholder: 'quantidade',
              fieldType: 'number',
            },
            {
              id: 'CesareanBirth',
              label: 'Parto cesárea:',
              conditions: [{ condition: 'Multípara - partos anteriores' }],
              placeholder: 'quantidade',
              fieldType: 'number',
            },
            {
              id: 'Abortion',
              label: 'Aborto:',
              conditions: [{ condition: 'Multípara - partos anteriores' }, { condition: 'Nulípara' }],
              placeholder: 'quantidade',
              fieldType: 'number',
            },
          ],
        },
        'question05-1': {
          sequence: 16,
          type: 'radio',
          label: '5.1. Se teve "Parto vaginal" anterior, houve "episiotomia"?',
          validator: {
            dataType: 'string',
            required: false,
          },
          fullWidth: true,
          options: ['Sim', 'Não'],
        },
        'question05-2': {
          sequence: 17,
          type: 'radio',
          label: '5.2. Se teve "Parto vaginal" anterior, houve "rafia de laceração"?',
          validator: {
            dataType: 'string',
            required: false,
          },
          fullWidth: true,
          options: ['Sim', 'Não', 'Não sabe dizer'],
        },
        'question06': {
          sequence: 18,
          type: 'checkbox',
          label: '6. Histórico de incontinência?',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: ['Fezes', 'Gases', 'Urina', 'Nenhum'],
        },
      },
    },
    {
      title: 'Dados do Parto Atual',
      questions: {
        question07: {
          sequence: 19,
          type: 'checkbox',
          label: '7. Indução?',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: ['Não', 'Misoprostol', 'Krause', 'Ocitocina'],
          requestDetails: [
            {
              id: 'Misoprostol',
              label: 'Para Misoprostol, indique a qtde de comprimidos?',
              conditions: [{ condition: 'Misoprostol' }],
              placeholder: 'quantidade de comprimidos',
              fieldType: 'number',
            },
            {
              id: 'Krause',
              label: 'Para Krause, quantidade de horas utilizado?',
              conditions: [{ condition: 'Krause' }],
              placeholder: 'total de horas',
              fieldType: 'number',
            },
            {
              id: 'Ocitocina',
              label: 'Para Ocitocina, quantidade de horas utilizado?',
              conditions: [{ condition: 'Ocitocina' }],
              placeholder: 'total de horas',
              fieldType: 'number',
            },
          ],
        },
        question08: {
          sequence: 20,
          type: 'radio',
          label: '8. Uso de ocitocina para condução?',
          helperText: 'ver checagem em prescrição médica até a hora do parto',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Tempo menor que 6 horas', 'Tempo maior que 6 horas', 'Não se aplica'],
          requestDetail: {
            hidden: true,
            label: 'Especifique o tempo exato em horas?',
            conditions: [{ condition: 'Tempo menor que 6 horas' }, { condition: 'Tempo maior que 6 horas' }],
            placeholder: 'em horas (ex: 5h30)',
          },
        },
        question09: {
          sequence: 21,
          type: 'radio',
          label: '9. Tempo do período expulsivo?',
          helperText: 'a partir do momento que foi registrado 10cm de dilatação',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Menor que 1 hora', 'Entre 1 e 2 horas', 'Maior que 2 horas'],
          requestDetail: {
            label: 'Especifique o tempo exato em horas?',
            required: true,
            placeholder: 'em horas (ex: 1h30 ou 59min)',
          },
        },
        question10: {
          sequence: 22,
          type: 'checkbox',
          label: '10. Métodos não farmacológicos para alívio da dor?',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Agachamento',
            'Aromaterapia',
            'Banco',
            'Bola',
            'Banho',
            'Deambulação',
            'Massagem',
            'Musicoterapia',
            'Outros',
          ],
          requestDetail: {
            label: 'Para "Outros", especifique?',
            conditions: [{ condition: 'Outros' }],
          },
          isRequestDetailOther: true,
        },
        question11: {
          sequence: 23,
          type: 'radio',
          label: '11. Presença de acompanhante?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Sim', 'Não'],
        },
        question12: {
          sequence: 24,
          type: 'date',
          fieldType: 'date',
          label: '12. Data do parto?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          decoration: true,
          replicateTo: ['birthDate'],
        },
        question13: {
          sequence: 25,
          type: 'text',
          fieldType: 'text',
          label: '13. Horário do parto?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          placeholder: 'HH:MM (ex: 12:50 ou 22:30)',
          decoration: true,
        },
        question14: {
          sequence: 26,
          type: 'text',
          fieldType: 'text',
          label: '14. Tipo de parto?',
          defaultValue: 'PV',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          decoration: true,
        },
        question15: {
          sequence: 27,
          type: 'radio',
          label: '15. Apresentação fetal?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Cefálica', 'Pélvica'],
        },
        question16: {
          sequence: 28,
          type: 'radio',
          label: '16. Local do parto?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['CPN', 'PA', 'PPP', 'Outros'],
          requestDetail: {
            label: 'Para "Outros", especifique?',
            conditions: [{ condition: 'Outros' }],
          },
          isRequestDetailOther: true,
        },
        question17: {
          sequence: 29,
          type: 'radio',
          label: '17. Posição de parto?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Banqueta', 'Cócoras', 'Em pé', 'Lateral', 'Quatro apoios', 'Semi-sentada', 'Outros'],
          requestDetail: {
            label: 'Para "Outros", especifique?',
            conditions: [{ condition: 'Outros' }],
          },
          isRequestDetailOther: true,
        },
        question18: {
          sequence: 30,
          type: 'radio',
          label: '18. Tipo de laceração?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: [
            '2º grau em fúrcula com MAIS de 1cm de distância do esfíncter anal',
            '2º grau em fúrcula com MENOS de 1cm do esfíncter anal',
          ],
        },
        question19: {
          sequence: 31,
          type: 'radio',
          label: '19. Episiotomia médio lateral direita?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Sim', 'Não'],
        },
        question20: {
          sequence: 32,
          type: 'radio',
          label: '20. Tipo de anestesia?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          options: ['Local', 'Raqui', 'Outros'],
          requestDetail: {
            label: 'Para "Outros", especifique?',
            conditions: [{ condition: 'Outros' }],
          },
          isRequestDetailOther: true,
        },
        question21: {
          sequence: 33,
          type: 'checkbox',
          label: '21. Profissional que assistenciou ao parto?',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Enfermeira(o) obstetra',
            'Residente de enfermagem R1',
            'Residente de enfermagem R2',
            'Médica(o) obstetra',
            'Residente de medicina R1',
            'Residente de medicina R2',
            'Outros',
          ],
          requestDetail: {
            label: 'Para "Outros", especifique?',
            conditions: [{ condition: 'Outros' }],
          },
          isRequestDetailOther: true,
        },
      },
    },
    {
      title: 'Dados do RN',
      questions: {
        birthDate: {
          sequence: 34,
          type: 'date',
          fieldType: 'date',
          label: 'Data de nascimento?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: true,
          decoration: true,
        },
        gestationalAge: {
          sequence: 35,
          type: 'gestational-age',
          label: 'Idade gestacional?',
          validator: {
            dataType: 'object',
            required: true,
          },
          fullWidth: true,
        },
        birthWeight: {
          sequence: 36,
          type: 'text',
          fieldType: 'number',
          label: 'Peso ao nascer?',
          placeholder: 'em gramas (ex: 3599, 3455, 2769)',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
        gender: {
          sequence: 37,
          type: 'radio',
          label: 'Sexo?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: ['Masculino', 'Feminino'],
        },
        apgar1minute: {
          sequence: 38,
          type: 'select',
          options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          fieldType: 'number',
          label: 'APGAR 1 minuto?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
        apgar5minute: {
          sequence: 39,
          type: 'select',
          options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          label: 'APGAR 5 minutos?',
          validator: {
            dataType: 'number',
            required: true,
          },
          fullWidth: false,
        },
        cordClamping: {
          sequence: 40,
          type: 'radio',
          label: 'Clampeamento de cordão?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: ['Imediato', 'Tardio'],
        },
        skinToSkinContact: {
          sequence: 41,
          type: 'radio',
          label: 'Contato pele a pele?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: ['Sim', 'Não'],
        },
        breastfeedingInTheFirstHour: {
          sequence: 42,
          type: 'radio',
          label: 'Amamentação na 1ª hora?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: ['Sim', 'Não'],
        },
        rnDestiny: {
          sequence: 43,
          type: 'radio',
          label: 'Destino do RN',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: ['AC', 'UTI', 'UCINCO'],
        },
      },
    },
    {
      title: 'Avaliação Perineal',
      description:
        'Avaliação perineal da enfermeira de acordo com escala REEDA (redness, edema, ecchymosis, discharge, approximation) e Morais et al',
      questions: {
        'question22-1': {
          sequence: 44,
          type: 'radio',
          label: '22.1 Realizar a avaliação perineal de acordo com escala REEDA [HIPEREMIA]?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: [
            'Score 0 - Nenhuma',
            'Score 1 - Até 0,25 cm da incisão bilateralmente',
            'Score 2 - Até 0,5 cm da incisão bilateralmente',
            'Score 3 - Além de 0,5 cm da incisão bilateralmente',
          ],
        },
        'question22-2': {
          sequence: 45,
          type: 'radio',
          label: '22.2 Realizar a avaliação perineal de acordo com escala REEDA [EDEMA]?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: [
            'Score 0 - Nenhuma',
            'Score 1 - Perineal a menos de 1 cm a partir da incisão',
            'Score 2 - Perineal ou vulvar de 1 a 2 cm da incisão',
            'Score 3 - Perineal ou vulvar além de 2 cm da incisão',
          ],
        },
        'question22-3': {
          sequence: 46,
          type: 'radio',
          label: '22.3 Realizar a avaliação perineal de acordo com escala REEDA [EQUIMOSE]?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: [
            'Score 0 - Nenhuma',
            'Score 1 - Até 0,25 cm da incisão bilateralmente ou 0,25 cm unilateralmente',
            'Score 2 - Entre 0,25 e 1 cm bilateralmente ou entre 0,5 e 2 cm unilateralmente',
            'Score 3 - Além de 1 cm bilateralmente ou 2 cm unilateralmente',
          ],
        },
        'question22-4': {
          sequence: 47,
          type: 'radio',
          label: '22.4 Realizar a avaliação perineal de acordo com escala REEDA [SECREÇÃO]?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: [
            'Score 0 - Nenhuma',
            'Score 1 - Serosa',
            'Score 2 - Serosanguínea',
            'Score 3 - Sanguinolenta, purulenta',
          ],
        },
        'question22-5': {
          sequence: 48,
          type: 'radio',
          label: '22.5 Realizar a avaliação perineal de acordo com escala REEDA [COAPTAÇÃO]?',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: [
            'Score 0 - Fechada',
            'Score 1 - Pele separada 3 mm ou menos',
            'Score 2 - Pele e subcutâneo separados',
            'Score 3 - Pele, subcutâneo e músculo separados',
          ],
        },
        'question22-6': {
          sequence: 49,
          type: 'text',
          fieldType: 'number',
          label: '22.6 Score TOTAL REEDA?',
          validator: {
            dataType: 'number',
            required: true,
          },
          fullWidth: false,
          decoration: true,
        },
        'question23': {
          sequence: 50,
          type: 'radio',
          label:
            '23. Realizar a avaliação de edema da região vulvoperineal por meio da inspeção e classificar segundo a escala de 0 a 4.',
          validator: {
            dataType: 'string',
            required: true,
          },
          fullWidth: false,
          options: [
            '0 – não apresenta sinais de tumefação, hiperemia ou abaulamento em nenhuma região do períneo;',
            '1 – apresenta sinais de edema apenas nos pequenos lábios;',
            '2 – o edema se estende dos pequenos aos grandes lábios, inclusive com prejuízo de contornos e/ou simetria;',
            '3 – sinais de edema abrangendo pequenos, grandes lábios e vestíbulo;',
            '4 – o edema invade o corpo perineal.',
          ],
        },
      },
    },
    {
      title: 'Avaliação do Bem estar da Puérpera',
      description: 'Para cada afirmação a seguir marque a melhor opção que te representa:',
      questions: {
        question24: {
          sequence: 51,
          type: 'radio',
          label: '24. Capacidade de sentar',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Não consigo sentar',
            'Consigo sentar com muito desconforto',
            'Consigo sentar com um pouco de desconforto',
            'Consigo sentar confortavelmente',
          ],
        },
        question25: {
          sequence: 52,
          type: 'radio',
          label: '25. Capacidade de andar',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Não consigo andar',
            'Consigo andar com muito desconforto',
            'Consigo andar com um pouco de desconforto',
            'Consigo andar sem dor no local dos pontos',
          ],
        },
        question26: {
          sequence: 53,
          type: 'radio',
          label: '26. Sobre a dor perineal (no local dos pontos)',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: ['Não sinto dor', 'Sinto dor severa', 'Sinto dor moderada', 'Sinto dor leve'],
        },
        question27: {
          sequence: 54,
          type: 'radio',
          label: '27. O local dos pontos ou corte infeccionou?',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Não houve infecção',
            'O profissional precisou refazer os pontos',
            'Utilizei antibiótico durante a internação',
          ],
        },
        question28: {
          sequence: 55,
          type: 'radio',
          label: '28. Capaz de evacuar sem dor/ ou medo de rompimento dos pontos.',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Não consegui',
            'Consegui, com muita dor',
            'Tive medo, mas consegui sem dor',
            'Consegui tranquilamente',
          ],
        },
        question29: {
          sequence: 56,
          type: 'radio',
          label: '29. Capaz de urinar sem dor/ ou medo.',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Não consegui',
            'Consegui, com muita dor',
            'Tive medo, mas consegui sem dor',
            'Consegui tranquilamente',
          ],
        },
        question30: {
          sequence: 57,
          type: 'radio',
          label: '30. Informações de profissionais',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Não recebi informações escritas e/ou verbais no hospital em relação ao cuidado com os pontos',
            'Recebi informações escritas e/ou verbais no hospital em relação ao cuidado com os pontos que foram suficientes',
            'Recebi informações apenas verbais no hospital em relação ao cuidado com os pontos mas não entendi direito',
            'Recebi informações escritas e/ou verbais no hospital em relação ao cuidado com os pontos mas fiz o que um conhecido me orientou',
          ],
        },
        question31: {
          sequence: 58,
          type: 'radio',
          label: '31. Conforto ao alimentar o bebê sentada (mama ou mamadeira)',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Tive muito desconforto com os pontos e não consegui alimentar meu bebê',
            'Consegui, porém, com muita dor',
            'Consegui, porém, com pouca dor',
            'Consegui alimentá-lo tranquilamente',
          ],
        },
        question32: {
          sequence: 59,
          type: 'radio',
          label: '32. Sensação de "voltar ao meu normal"',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Não me sinto bem comigo, acho que irei demorar para "voltar ao meu normal"',
            'Me sinto bem, porém ainda desconfortável, acredito que logo estarei "de volta ao meu normal"',
            'Me sinto muito bem, "de volta ao meu normal"',
          ],
        },
        question33: {
          sequence: 60,
          type: 'checkbox',
          label: '33. Incontinência de urina, fezes e/ou gases',
          validator: {
            dataType: 'array',
            required: true,
          },
          fullWidth: true,
          options: [
            'Faço xixi sem perceber',
            'Solto pum sem querer',
            'Tenho que sair correndo para o banheiro, se não faço cocô na roupa',
            'Consigo segurar como antes e fazer o xixi, cocô e soltar pum na hora certa',
          ],
        },
      },
    },
  ],
};

export { Collect1Form };
